import { NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { INDRASiteIsDownComponent } from './site-is-down/site-is-down.indra.component';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { Observable } from 'rxjs';
import * as fromStore from '../../store';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';


@NgModule({
  	declarations: [INDRASiteIsDownComponent],
  	imports: [
		SharedModule,
		CommonModule,
		SVGModule
	]


})
export class IsDownModule implements OnInit, OnDestroy{

	isAlive = true;
	isMobile$: Observable<boolean> = this.store.select(fromStore.isScreenMobile);
	isMobile: boolean = false;
	status: string = '';

	constructor(private store: Store<fromStore.State>) {
		this.isMobile$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isMobile = value;
			});
	}

	async ngOnInit() {

	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}
}
